import { useRestaurantModel } from '@entities/restaurant'
import { useTipsModel } from '@entities/tips'

export const applyAdvanceCheckType = (route: any, redirect: any) => {
  const restaurantModel = useRestaurantModel()
  const tipsModel = useTipsModel()

  const baseUrl = process.env.TIPS_URL || 'http://localhost:3333'
  const restName = restaurantModel.code
  const id = route.params.id
  const platform = route.query.platform
  const orderGuid = route.query.order_guid
  const dopID = route.query.i

  // Формируем ссылку для перехода в tips
  let tipsUrl = `${baseUrl}/${restName}/${id}?order_guid=${orderGuid}&qr_type=precheck2&platform=${platform}&restaurant=${route.params.restaurant}`
  if (dopID) {
    tipsUrl += `&i=${dopID}`
  }

  if (restaurantModel.advanceCheckType === 'TIPS') {
    redirect(tipsUrl)
  }

  if (restaurantModel.advanceCheckType === 'ORDER_AND_TIPS') {
    tipsModel.setTipsUrl(tipsUrl)
  }
}

export const checkLinkTips = (route: any, redirect: any) => {
  if (process.server) {
    applyAdvanceCheckType(route, redirect)
  }
}

//

// http://localhost:3333/https://stage-ssr.zedform.ru/bef2b323-8a8b-4eca-8c76-a44cdff833f1/8?&qr_type=precheck2&platform=iiko&order_guid=f2a95043-8909-4f02-928b-4a295191bafa

// https://tips.stage.tapper.zedform.ru/testrkeeper/1000004?checksum=300&platform=iiko&table_name=1&qr_type=precheck&table_id=1111

// http://localhost:3333/500550001/1000039?qr_type=precheck2&platform=rkeeper

// https://tapper.cloud/500550001/1000039?<order_guid>&platform=rkeeper&qr_type=precheck2;

// rkeeper
// 500550001/1000043?qr_type=precheck2&platform=rkeeper&order_guid={094A4494-488A-47C2-959A-4F2035FD61D1}

// iiko
// bef2b323-8a8b-4eca-8c76-a44cdff833f1/8?&qr_type=precheck2&platform=iiko&order_guid=f2a95043-8909-4f02-928b-4a295191bafa

// iiko test
// 1cecdd21-bd93-c191-0184-3225a5240010/5?qr_type=precheck2&platform=iiko&order_guid=4f8601c0-77a7-481e-ba3e-b6d529371357
// bef2b323-8a8b-4eca-8c76-a44cdff833f1/3?qr_type=precheck2&platform=iiko&order_guid=f641d717-43c8-490b-9070-682472b51e59

// ssr
// http://localhost:3333/ bef2b323-8a8b-4eca-8c76-a44cdff833f1/3?qr_type=precheck2&platform=iiko&order_guid=bb8d9654-6b72-4e66-a76d-5a4f73233cdb

// http://localhost:3333/keeper-3459/1000045
// rkkeper http://localhost:3333/ 500550002/1000045?qr_type=precheck2&platform=rkeeper&order_guid={159BB510-C4F9-40D2-BA2E-2B9E5B66B1DB}

// https://tapper-dev.ru/500550002/1000045?qr_type=precheck2&platform=rkeeper&order_guid={AC66A73B-78AA-4FF5-97EA-4BF7E1FE80C1}

// rkeeper test keeper-3307
